import React, { useState } from "react";
import axios from "axios";
// If your Button doesn't forward htmlType to a real <button>, use a native button instead.
import Button from "../../../../iconosv0/src/components/Button/Button.jsx";
import "./../stylesloin.scss";

export default function ElementNewPassword({ email, t, onDone,  eyeClosedIcon,
     eyeOpenIcon  }) {
  const tr = (k, fb) => (typeof t === "function" ? t(k) : fb);
  const MIN_LEN = 8;

  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [msg, setMsg] = useState("");
  const [saving, setSaving] = useState(false);
  const [show, setShow] = useState(false);

  const isTooShort = p1.length > 0 && p1.length < MIN_LEN;
  const mismatch   = p2.length > 0 && p1 !== p2;
  const formValid  = p1.length >= MIN_LEN && p1 === p2;

  const submit = async (e) => {
    e.preventDefault();
    setMsg("");

    if (isTooShort) {
      setMsg(tr("passwordTooShort", `Use at least ${MIN_LEN} characters.`));
      return;
    }
    if (mismatch) {
      setMsg(tr("passwordMismatchError", "Passwords do not match."));
      return;
    }

    try {
      setSaving(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/reset-password`,
        { email, newPassword: p1 }
      );
      setMsg(res?.data?.message || tr("resetOk","Password updated."));
      onDone?.();
    } catch (err) {
      setMsg(tr("resetPasswordError","Error resetting password."));
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="auth">
      <span aria-hidden className="page-bottom-glow" />
      <section className="container auth__container">
        <header className="auth__header">
          <h1>{tr("setNewTitle","Set a new password")}</h1>
          <p>{email}</p>
        </header>

        <form className="auth__card" onSubmit={submit} noValidate>
          <div className="field">
            <label htmlFor="np-1">{tr("passwordLabel","New password")}</label>
            <div className="password-wrap">
              <input
                id="np-1"
                type={show ? "text" : "password"}
                placeholder={tr("enterNewPasswordPlaceholder","Enter new password")}
                autoComplete="new-password"
                required
                minLength={MIN_LEN}
                aria-invalid={isTooShort}
                value={p1}
                onChange={(e) => setP1(e.target.value)}
              />
              <button
                type="button"
                className="toggle-pwd"
                aria-pressed={show}
                aria-label={show ? tr("hidePassword","Hide password") : tr("showPassword","Show password")}
                onClick={() => setShow(s => !s)}
              >
                {show ? eyeClosedIcon() : eyeOpenIcon()}
              </button>
            </div>
            {isTooShort && (
              <small className="field-hint">
                {tr("passwordTooShort", `Use at least ${MIN_LEN} characters.`)}
              </small>
            )}
          </div>

          <div className="field">
            <label htmlFor="np-2">{tr("confirmPasswordLabel","Confirm password")}</label>
            <div className="password-wrap">
              <input
                id="np-2"
                type={show ? "text" : "password"}
                placeholder={tr("confirmNewPasswordPlaceholder","Confirm new password")}
                autoComplete="new-password"
                required
                minLength={MIN_LEN}
                aria-invalid={mismatch}
                value={p2}
                onChange={(e) => setP2(e.target.value)}
              />
              <button
                type="button"
                className="toggle-pwd"
                aria-pressed={show}
                aria-label={show ? tr("hidePassword","Hide password") : tr("showPassword","Show password")}
                onClick={() => setShow(s => !s)}
              >
                {show ? eyeClosedIcon() : eyeOpenIcon()}
              </button>
            </div>
            {mismatch && (
              <small className="field-hint">
                {tr("passwordMismatchError","Passwords do not match.")}
              </small>
            )}
          </div>

          {/* If your design Button supports htmlType, use it; otherwise switch to native button */}
      <button
  type="submit"
  className="btn-primary w-full"
  disabled={saving || !formValid}
>
  {tr("resetPasswordButton","Reset password")}
</button>

          {msg ? <p className="auth__message" aria-live="polite">{msg}</p> : null}
        </form>
      </section>
    </main>
  );
}
